import { Controller } from '@hotwired/stimulus'

const OPEN_CLASS = 'beachy-multiselect-open'
const ACTIVE_CLASS = 'beachy-multiselect-active'

// A filter that is a Select when closed and a menu of checkbox rows when open.
// The face shows "All statuses", the one picked label, or "2 statuses"; the
// active class keeps the border teal while anything is picked.
export default class extends Controller {
  static targets = ['face', 'menu', 'option', 'label']
  static values = { noun: String, all: String }

  connect() {
    this.dismiss = this.dismiss.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    this.stopListening()
  }

  toggle() {
    if (this.element.classList.contains(OPEN_CLASS)) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.element.classList.add(OPEN_CLASS)
    this.faceTarget.setAttribute('aria-expanded', 'true')
    document.addEventListener('mousedown', this.dismiss)
    document.addEventListener('keydown', this.onKeydown)
  }

  close() {
    this.element.classList.remove(OPEN_CLASS)
    this.faceTarget.setAttribute('aria-expanded', 'false')
    this.stopListening()
  }

  update() {
    const picked = this.optionTargets
      .map((option, index) => option.checked ? this.labelTargets[index].textContent.trim() : null)
      .filter(Boolean)

    if (picked.length === 0) {
      this.faceTarget.textContent = this.allValue
    } else if (picked.length === 1) {
      this.faceTarget.textContent = picked[0]
    } else {
      this.faceTarget.textContent = `${picked.length} ${this.nounValue}`
    }
    this.element.classList.toggle(ACTIVE_CLASS, picked.length > 0)
  }

  stopListening() {
    document.removeEventListener('mousedown', this.dismiss)
    document.removeEventListener('keydown', this.onKeydown)
  }

  dismiss(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
